module.exports = __webpack_public_path__ + "static/logofun-fa563ec5323c802e2f64f4fee5b64c1d.png";